import { ThemeEvents } from '@theme/events';

/* FIX: installment badge — update PDP pills when variant price crosses thresholds */
const LABEL_2 = 'Peşin Fiyatına 2 Taksit';
const LABEL_3 = 'Peşin Fiyatına 3 Taksit';

/**
 * @param {number} priceCents
 * @returns {string}
 */
function installmentLabelForPrice(priceCents) {
  if (priceCents >= 1000000) return LABEL_3;
  if (priceCents >= 500000) return LABEL_2;
  return '';
}

/**
 * @param {number} priceCents
 */
function updateInstallmentBadges(priceCents) {
  document.querySelectorAll('[data-installment-badge]').forEach((badge) => {
    if (!(badge instanceof HTMLElement)) return;

    const label = installmentLabelForPrice(priceCents);
    const labelEl = badge.querySelector('[data-installment-label]');

    if (label) {
      if (labelEl) {
        labelEl.textContent = label;
      } else {
        badge.textContent = label;
      }
      badge.hidden = false;
      badge.classList.remove('hidden');
    } else {
      if (labelEl) {
        labelEl.textContent = '';
      } else {
        badge.textContent = '';
      }
      badge.hidden = true;
      badge.classList.add('hidden');
    }
  });
}

/**
 * @param {CustomEvent} event
 */
function handleVariantUpdate(event) {
  const price = event.detail?.resource?.price;
  if (typeof price !== 'number') return;
  updateInstallmentBadges(price);
}

document.addEventListener(ThemeEvents.variantUpdate, handleVariantUpdate);
